module.exports = __webpack_public_path__ + "img/r-1.4dd02ce.png";